(function () {
    'use strict';

    angular
        .module('app')
        .factory('load', load);

    load.$inject = ['$document', '$q', '$timeout',];

    function load($document, $q, $timeout) {
        var document = $document[0],
            promises = {},
            service = {
                loadScript: loadScript,
                loadCSS: loadCSS,
                unloadCSS: unloadCSS,
                runBase64: runBase64,
            };

        return service;

        function loader(type, url) {
            if (typeof promises[url] === 'undefined') {
                var deferred = $q.defer(),
                    element = null;

                if('script' === type){
                    var script = document.createElement('script');
                    script.src = url;
                    document.body.appendChild(script);
                    element = script;
                } else if ('css' === type){
                    var style = document.createElement('link');
                    style.rel = 'stylesheet';
                    style.type = 'text/css';
                    style.href = url;
                    document.head.appendChild(style);
                    element = style;
                }

                element.onload = element.onreadystatechange = function (e) {
                    if (element.readyState && element.readyState !== 'complete' && element.readyState !== 'loaded') {
                        return;
                    }

                    $timeout(function () {
                        deferred.resolve(e);
                    });
                };
                element.onerror = function (e) {
                    $timeout(function () {
                        deferred.reject(e);
                    });
                };

                promises[url] = deferred.promise;
            }

            return promises[url];
        }

        function loadScript(src){
            return loader('script', src);
        }

        function loadCSS(href){
            return loader('css', href);
        }

        function unloadCSS(href) {
            delete promises[href];
            var head = document.head;

            if (head) {
                var css = head.querySelector('[href="' + href + '"]');
                if (css) {
                    css.remove();
                    return true;
                }
            }

            return false;
        }

        function runBase64(code) {
            eval(atob(code)); // jshint ignore:line
        }
    }

})();